import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationSRLatn from './locales/sr-Latn/translation.json';
import translationSRCyrl from './locales/sr-Cyrl/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDE,
  },
  'sr-Latn': {
    translation: translationSRLatn,
  },
  'sr-Cyrl': {
    translation: translationSRCyrl,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // not needed for React
    },

    // If a key is missing, return the key itself
    returnNull: false,
    returnEmptyString: false,
    returnMissing: true,

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
  });

export default i18n;
